import { useLocale } from "../stores/locale";
import { Button } from "./button";
import { H1 } from "./h1";
import { Modal } from "./modal";

export function Alert({
  isOpen,
  header,
  message,
  onClose,
}: {
  isOpen: boolean;
  header: string;
  message: string;
  onClose: () => void;
}) {
  const t = useLocale((state) => state.locale);

  const closeModal = () => {
    onClose();
  };

  return (
    <Modal open={isOpen} size="xs" zIndex={1000} onClose={closeModal}>
      <div className="flex flex-col items-center gap-4">
        <H1>{header}</H1>
        <p>{message}</p>
        <Button severity="primary" onClick={closeModal}>
          {t.ok}
        </Button>
      </div>
    </Modal>
  );
}
